import styled from "@emotion/styled"
import { Checkbox as Primitive } from "radix-ui"
import { ComponentProps, ReactNode, forwardRef, useId } from "react"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import { FaMinus } from "@react-icons/all-files/fa/FaMinus"
import { DARKER_GREY_COLOR, ORANGE_COLOR } from "theme/colors"

const Intermediate = styled.div`
  width: 8px;
  height: 2px;
  background: #ffffff;
  border-radius: 3px;
  opacity: 1;
`

const Root = styled(Primitive.Root)<{ size?: "medium" | "large" }>`
  width: ${(p) => (p.size === "large" ? "19px" : "16px")};
  height: ${(p) => (p.size === "large" ? "19px" : "16px")};
  min-width: ${(p) => (p.size === "large" ? "19px" : "16px")};
  min-height: ${(p) => (p.size === "large" ? "19px" : "16px")};
  border-radius: 4px;
  border: 1px solid #03004e80;
  display: flex;
  align-items: center;
  justify-content: center;

  &[data-state="unchecked"] {
    background: white;
    box-shadow: inset 0 3px 6px #00000029;
  }

  &[data-state="checked"],
  &[data-state="indeterminate"] {
    background: ${ORANGE_COLOR};
    border-color: ${ORANGE_COLOR};
  }
  :hover {
    border-color: ${ORANGE_COLOR};
    box-shadow: inset 0 2px 4px #00000029;
  }
  :disabled {
    opacity: 0.5;
    background: ${DARKER_GREY_COLOR};
    border-color: ${DARKER_GREY_COLOR};
  }
`

const Indicator = styled(Primitive.Indicator)`
  line-height: 0;
`

export default forwardRef<
  HTMLButtonElement,
  ComponentProps<typeof Root> & { label?: ReactNode }
>(function Checkbox({ label, ...props }, ref) {
  const id = useId()
  return (
    <>
      <Root id={id} {...props} ref={ref}>
        <Indicator>
          {props.checked === "indeterminate" ? (
            <FaMinus color="white" size={props.size === "large" ? 12 : 10} />
          ) : (
            <FaCheck color="white" size={props.size === "large" ? 12 : 10} />
          )}
        </Indicator>
      </Root>
      {label ? <label htmlFor={id}>{label}</label> : null}
    </>
  )
})
